import { render } from "./SuccessOverlay.vue?vue&type=template&id=99e9fa42&ts=true"
import script from "./SuccessOverlay.vue?vue&type=script&lang=ts"
export * from "./SuccessOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__